/* Tattup mobile menu – see snippets/tt-mnav.liquid.
   Takes over the header burger (.logo-area .mobile-nav-toggle) before the theme's own handler (capture phase), so the
   old Symmetry drawer never opens. The menu markup is cloned from <template id="tt-mnav-tpl"> on the first open; its CSS
   is preloaded when the browser is idle after load, or right before the first open.
   Closes with: X, tap on the shade, Escape, swipe left, any link inside, browser back to a page from bfcache. */
(function () {
  'use strict';
  if (window.__ttMnav) return;
  window.__ttMnav = true;

  var tpl = document.getElementById('tt-mnav-tpl');
  if (!tpl || !('content' in tpl)) return;

  var cssHref = tpl.getAttribute('data-css');
  var cssReady = null;
  function loadCss() {
    if (cssReady) return cssReady;
    cssReady = new Promise(function (resolve) {
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = cssHref;
      l.onload = resolve;
      l.onerror = resolve;
      document.head.appendChild(l);
      setTimeout(resolve, 2500);
    });
    return cssReady;
  }
  function idle(fn) { (window.requestIdleCallback || function (f) { return setTimeout(f, 1500); })(fn, { timeout: 4000 }); }
  if (document.readyState === 'complete') idle(loadCss);
  else window.addEventListener('load', function () { idle(loadCss); }, { once: true });

  var root = null, panel = null, toggleBtn = null, isOpen = false, closeTimer = null;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function build() {
    root = tpl.content.firstElementChild.cloneNode(true);
    document.body.appendChild(root);
    /* inline scripts from the template (e.g. the localization form's auto-submit) do not run when cloned: re-create them */
    root.querySelectorAll('script').forEach(function (old) {
      var s = document.createElement('script');
      for (var k = 0; k < old.attributes.length; k++) s.setAttribute(old.attributes[k].name, old.attributes[k].value);
      s.textContent = old.textContent;
      old.parentNode.replaceChild(s, old);
    });
    panel = root.querySelector('.ttm__panel');
    root.querySelectorAll('.ttm-in').forEach(function (el, i) { el.style.setProperty('--i', Math.min(i, 14)); });

    root.addEventListener('click', function (e) {
      var c = e.target.closest('[data-ttm-close]');
      if (c) {
        if (!c.hasAttribute('data-wl-open')) e.preventDefault();
        close(!c.hasAttribute('data-wl-open'));
        return;
      }
      var a = e.target.closest('a[href]');
      if (a && !a.closest('.custom-select')) {
        var href = a.getAttribute('href') || '';
        if (href.charAt(0) === '#') { close(true); return; }
        /* real navigation: the panel stays until the next page paints; mark the tapped item */
        a.classList.add('is-tapped');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'Escape') { close(true); return; }
      if (e.key === 'Tab') trapTab(e);
    });

    /* swipe left to close */
    var x0 = null, y0 = null, dx = 0, horizontal = null;
    panel.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; dx = 0; horizontal = null;
    }, { passive: true });
    panel.addEventListener('touchmove', function (e) {
      if (x0 === null) return;
      var mx = e.touches[0].clientX - x0, my = e.touches[0].clientY - y0;
      if (horizontal === null && (Math.abs(mx) > 8 || Math.abs(my) > 8)) {
        horizontal = Math.abs(mx) > Math.abs(my) && !e.target.closest('.ttm__chips');
        if (horizontal) root.classList.add('is-drag');
      }
      if (!horizontal) return;
      dx = Math.min(0, mx);
      panel.style.transform = 'translate3d(' + dx + 'px,0,0)';
    }, { passive: true });
    panel.addEventListener('touchend', function () {
      if (horizontal) {
        root.classList.remove('is-drag');
        panel.style.transform = '';
        if (dx < -70) close(true);
      }
      x0 = null; horizontal = null; dx = 0;
    });
  }

  function focusables() {
    return Array.prototype.filter.call(
      panel.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), summary, select, [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; }
    );
  }
  function trapTab(e) {
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open(btn) {
    toggleBtn = btn || toggleBtn;
    loadCss().then(function () {
      if (!root) build();
      clearTimeout(closeTimer);
      root.hidden = false;
      root.querySelectorAll('.is-tapped').forEach(function (a) { a.classList.remove('is-tapped'); });
      /* wishlist count (assets/tt-wishlist.js only paints [data-wl-count] that exist at boot / on a change) */
      try {
        var n = window.TattupWishlist ? window.TattupWishlist.items().length : 0;
        root.querySelectorAll('[data-wl-count]').forEach(function (el) { el.textContent = n > 0 ? String(n) : ''; el.hidden = n === 0; });
      } catch (err) {}
      document.documentElement.classList.add('ttm-lock');
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
      /* two frames so the slide-in transition runs */
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        root.classList.add('is-open');
        isOpen = true;
        var x = root.querySelector('.ttm__x');
        if (x) x.focus({ preventScroll: true });
      }); });
    });
  }
  function close(restoreFocus) {
    if (!root || !isOpen) return;
    isOpen = false;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('ttm-lock');
    if (toggleBtn) {
      toggleBtn.setAttribute('aria-expanded', 'false');
      if (restoreFocus) toggleBtn.focus({ preventScroll: true });
    }
    closeTimer = setTimeout(function () { root.hidden = true; }, reduce ? 0 : 450);
  }

  /* the header burger: ours, before the theme's delegated handler on document (bubble phase) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.logo-area .mobile-nav-toggle');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    if (isOpen) close(true); else open(btn);
  }, true);

  /* coming back with the browser's back button (page restored from bfcache): menu closed */
  window.addEventListener('pageshow', function (e) { if (e.persisted && isOpen) close(false); });

  window.TattupMenu = { open: function () { open(document.querySelector('.logo-area .mobile-nav-toggle')); }, close: function () { close(false); } };
})();
